import { Switch } from '@headlessui/react';
import { Title } from 'components/atoms/Title';
import { SizesEnum } from 'components/atoms/Title/Title.enum';
import { useGrowthABExperimentsState } from 'hooks/useAssignGrowthABGroups';
import type { FC } from 'react';
import { ABTest } from 'types/growthExperiments.types';
import { isWeb } from 'utils/constants';

const GrowthExperiments: FC = () => {
  const { experiments, setExperiments } = useGrowthABExperimentsState();

  if (!isWeb) return null;
  return (
    <>
      <Title type={SizesEnum.h6}>Growth Experiments</Title>
      {Object.entries(experiments)
        .filter(([key]) => !key.includes('INTERCOM_'))
        .map(([key, value]) => {
          const enabled = value === ABTest.B;
          const experimentName = key?.replace(/_/g, ' ')?.toLowerCase();

          return (
            <div className="mt-6 p-6 bg-[#f8f8f8] rounded-10" key={key}>
              <div className="flex justify-between">
                <span className="capitalize">{experimentName}</span>

                <div className="flex items-center">
                  <span className="text-main">{ABTest.A}</span>
                  <Switch
                    checked={enabled}
                    onChange={(checked: boolean) =>
                      setExperiments({
                        ...experiments,
                        [key]: checked ? ABTest.B : ABTest.A,
                      })
                    }
                    className={`${
                      enabled ? 'bg-bank-900' : 'bg-revenues-900'
                    } relative inline-flex h-6 w-11 items-center rounded-full mx-2`}
                  >
                    <span className="sr-only">{experimentName}</span>
                    <span
                      className={`${
                        enabled ? 'translate-x-6' : 'translate-x-1'
                      } inline-block h-4 w-4 transform rounded-full bg-white transition`}
                    />
                  </Switch>
                  <span className="text-main">{ABTest.B}</span>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default GrowthExperiments;
